import { MobileGeneratorIcon } from '@/components/Icons';
import { Button, ButtonProps } from '@/components/ui/button';
import useEditorStore from '@/state/editor-store';
import useGeneratorStore from '@/state/generator-store';
import React from 'react';
import { useWatch } from 'react-hook-form';
import { useCredit } from '../../GenerateButton/useCredit';
import styles from './index.module.scss';

interface MobileGeneratorButtonProps extends ButtonProps {
  disabled?: boolean;
}

const MobileGeneratorButton: React.FC<MobileGeneratorButtonProps> = ({ disabled, ...props }) => {
  const { control, generatorType, isGeneratorDrawerShow, tracksCount } = useGeneratorStore();
  const { operator, duration: editorDuration } = useEditorStore();

  const duration = useWatch({
    control,
    name: 'duration',
    defaultValue: 0,
  });

  const credit = useCredit({ duration, operator, editorDuration, isGeneratorDrawerShow, generatorType, tracksCount });

  return (
    <Button
      className={`${styles.generatorButtonBg} flex flex-col w-full h-full p-2 text-lg text-accent-foreground rounded-none`}
      disabled={disabled}
      type="submit"
      size="full"
      {...props}
    >
      <div className={`${styles.generatorButton} relative w-full h-full flex justify-center rounded-lg`}>
        <div className="flex items-center justify-start px-4 py-2  pointer-events-none">
          <div className="flex flex-col">
            <div className="flex items-center">
              <span className="flex">
                <MobileGeneratorIcon />
              </span>
              <span className="flex items-center font-inter text-[1.4rem] ml-3 font-medium leading-[40px] tracking-[-0.02em] text-left text-white">
                Jenerate
              </span>
              <span className="ml-2 mt-[-12px] font-pressura-mono items-center font-inter text-[0.8rem] font-light leading-[40px] tracking-[-0.02em] text-left text-white ">
                {credit} CRDS
              </span>
            </div>
          </div>
        </div>
      </div>
    </Button>
  );
};

export default MobileGeneratorButton;
